export default {
  status: "stopped",
  quality: "high",
  muted: false,
  volume: 1,
  target: {}
};
